import React from "react";
import {
    MDBContainer,
    MDBCard,
    MDBCardBody,
    MDBListGroup,
    MDBListGroupItem,
    MDBIcon,
    MDBRow,
    MDBCol,
    MDBCardTitle,
    MDBCardHeader,
    MDBCardText,
    MDBBtn,
} from "mdb-react-ui-kit";
import Logo from "../../components/images/StreamsAIWhite.png";
import LogoDark from "../../components/images/StreamsAI.png";
import { admin_doc_url,api_serverUrl } from "../../apiclients/apiurls";

const HelpPage = () => {
     const session = JSON.parse(sessionStorage.getItem("admin_session")) ?? {};
    const msaURL = session?.msaURL ?? "";
    const footerText = session.footerText ?? session.wholesale_footertext ?? "©2026 PanTerra Networks, Inc. All rights reserved.";

    const links = [
        { title: "Streams Help", icon: "code", href: `${admin_doc_url}/docs/html/saas/StreamsWebHelp/index.htm` },
        { title: "Connect Help", icon: "code", href: `${admin_doc_url}/docs/html/ConnectHelp_v7/index.htm` },
        { title: "Streams Quickstart Guide", icon: "file-pdf", href: `${admin_doc_url}/docs/pdfs/saas/QuickstartUsers.pdf` },
        { title: "Polycom Quickstart Guide", icon: "file-pdf", href: `${admin_doc_url}/docs/pdfs/PolycomQuickStartGuide.pdf` },
        { title: "Voicemail Instructions", icon: "file-pdf", href: `${admin_doc_url}/docs/pdfs/VoicemailInstructionsChart.pdf` },
        { title: "Yealink Quickstart Guide", icon: "file-pdf", href: `${admin_doc_url}/docs/pdfs/YealinkQuickStartGuide.pdf` },
        { title: "Grandstream Quickstart Guide", icon: "file-pdf", href: `${admin_doc_url}/docs/pdfs/Grandstream_Quick_Start_Guide.pdf` },
        { title: "Salesforce Lightning CTI Help", icon: "code", href: `${admin_doc_url}/docs/html/OpenCTIHelp/OpenCTI_Help_Lightning.html` },
        { title: "Zoho Integration Help", icon: "code", href: `${api_serverUrl}docs/pdfs/Zoho_CRM_Integration_with_StreamsAI_Help.pdf` },
        { title: "Greeting Manager", icon: "file-pdf", href: `${admin_doc_url}/docs/pdfs/RecordingaGreetingviatheTelephonyGreetingManager.pdf` },
        { title: "Zendesk Integration Help", icon: "code", href: `${admin_doc_url}/docs/html/Zendesk_Integration_with_Streams/Streams_Integration_with_Zendesk.htm` },
        { title: "End User Agreement", icon: "handshake", href: msaURL },
    ];

    const themeBasedLogo = localStorage.getItem("selectedColorTheme");
    const loginEmail = JSON.parse(sessionStorage.getItem("admin_session")).mailId
    console.log("msaURL :::::: " + JSON.stringify(loginEmail));

    return (
        <>
            <MDBCard className="p-0">
                <MDBCardBody className="helpBg p-0">

                    <MDBCardHeader className="d-flex align-items-center justify-content-between shadow-2 px-4 bg-light">
                        <img src={themeBasedLogo == "dark" ? Logo : LogoDark} className="logo" alt="" style={{ height: "45px", width: "auto" }} />
                        <strong>
                            {loginEmail}
                        </strong>
                    </MDBCardHeader>

                    <MDBContainer className="mt-5">

                        <MDBCardTitle className="mb-4 fs-3">
                            Help
                        </MDBCardTitle>

                        <MDBRow>
                            {links.map((link, index) => (
                                <MDBCol sm={12} lg={4} md={4} className="mb-4 cursor-pointer" tag="a" href={link.href} target="_blank">

                                    <MDBCard className="shadow-2 rounded-5">
                                        <MDBCardBody>
                                            <div className="d-flex align-items-center" style={{ paddingTop: "10px", paddingBottom: "10px" }}>

                                                <div style={{ width: "55px", height: "40px" }} className="d-flex align-items-center justify-content-center">
                                                    <MDBIcon fas icon={link.icon} color={link.icon === "handshake" ? "primary" : "danger"} size="2x" />
                                                </div>
                                                <div className="fw-bold">
                                                    {link.title}
                                                </div>
                                            </div>

                                        </MDBCardBody>
                                    </MDBCard>

                                </MDBCol>
                            ))}
                        </MDBRow>


                        {/* <MDBListGroup flush>
                    {links.map((link, index) => (
                        <MDBListGroupItem key={index} tag="a" href={link.href} target="_blank"
                            rel="noopener noreferrer"
                            className="d-flex align-items-center" style={{ paddingTop: "10px", paddingBottom: "10px" }}>
                            <div style={{ width: "55px", height: "40px" }} className="d-flex align-items-center justify-content-center">
                                <MDBIcon fas icon={link.icon} className="text-danger" size="xl" />
                            </div>
                            {link.title}
                        </MDBListGroupItem>
                    ))}
                </MDBListGroup> */}
                    </MDBContainer>
                    <div className="mt-4 text-center text-muted position-absolute bottom-0 start-50 translate-middle">
                        <small>{footerText} |<a href="#" onClick={(e) => { e.preventDefault(); window.open('/privacypolicy', '_blank'); }} className="text-small ps-2">Privacy Policy</a></small>
                    </div>

                </MDBCardBody>
            </MDBCard>
        </>
    );
};

export default HelpPage;